var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{class:_vm.listStyle},[_c('List',{attrs:{"__list":_vm.dataArray,"__isOnLoad":_vm.isListOnload,"__editMode":this.onEditionId != null,"__idxOnEdition":this.onEditionIdx,"public-page-slug":_vm.publicPageSlug,"catalog-mode":_vm.catalogMode,"is-admin":_vm.isAdmin}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }